
const ViewImage = (props) => {
  //const imageUrl = decodeURIComponent(props.match.params.imageUrl);
  const href = window.location.href;
  const encodedUrl = href.split("/file/")[1];

  return (
    <div
      style={{
        height: "100vh",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // border: "1px solid red",
      }}
    >
      <img
        style={{
          maxHeight: "100%",
          maxWidth: "100%",
        }}
        src={encodedUrl}
        alt="File Viewer"
      />
    </div>
  );
};

export default ViewImage;
